import { GeoAutocompleteOption, Suggestion } from '../types';

export const SUGGESTION_GROUP_NAMES = {
  HISTORY: 'Ранее вы искали',
  POPULAR: 'Популярные направления',
  NEAREST: 'Места рядом',
  RUSSIAN: 'Россия',
  OTHER_COUNTRIES: 'Другие страны',
};

export const SUGGESTION_TYPES = {
  TOP: 'top',
  NEAREST: 'nearest',
  SEARCH: 'search',
} as const;

export const groupSuggestionsByCategories = (
  suggestions: GeoAutocompleteOption[],
  historySuggestions: GeoAutocompleteOption[]
): Suggestion[] => {
  if (!suggestions.length) return [];

  const result: Suggestion[] = [];
  const topSuggestions: GeoAutocompleteOption[] = [];
  const nearestSuggestions: GeoAutocompleteOption[] = [];

  suggestions.forEach((suggestion) => {
    const isSearchType = suggestion.type === SUGGESTION_TYPES.SEARCH;
    if (isSearchType) return;

    const hasSuggestionInHistory = historySuggestions.some(
      (historySuggestion) => suggestion.value === historySuggestion.value
    );
    if (hasSuggestionInHistory) return;

    if (suggestion.type === SUGGESTION_TYPES.TOP) {
      topSuggestions.push(suggestion);
    } else if (suggestion.type === SUGGESTION_TYPES.NEAREST) {
      nearestSuggestions.push(suggestion);
    }
  });

  if (historySuggestions.length) {
    result.push(
      { label: SUGGESTION_GROUP_NAMES.HISTORY, isOptionGroup: true },
      ...historySuggestions
    );
  }

  if (nearestSuggestions.length) {
    result.push(
      { label: SUGGESTION_GROUP_NAMES.NEAREST, isOptionGroup: true },
      ...nearestSuggestions
    );
  }

  if (topSuggestions.length) {
    result.push({ label: SUGGESTION_GROUP_NAMES.POPULAR, isOptionGroup: true }, ...topSuggestions);
  }

  return result;
};

export const groupSuggestionsByCountries = (suggestions: GeoAutocompleteOption[]): Suggestion[] => {
  if (!suggestions.length) return [];

  const result: Suggestion[] = [];
  const russianSuggestions: GeoAutocompleteOption[] = [];
  const otherCountriesSuggestions: GeoAutocompleteOption[] = [];

  suggestions.forEach((suggestion) => {
    if (suggestion.country === 'Россия') {
      russianSuggestions.push(suggestion);
    } else {
      otherCountriesSuggestions.push(suggestion);
    }
  });

  if (russianSuggestions.length) {
    result.push(
      { label: SUGGESTION_GROUP_NAMES.RUSSIAN, isOptionGroup: true },
      ...russianSuggestions
    );
  }

  if (otherCountriesSuggestions.length) {
    result.push(
      { label: SUGGESTION_GROUP_NAMES.OTHER_COUNTRIES, isOptionGroup: true },
      ...otherCountriesSuggestions
    );
  }

  return result;
};
